import React, { useState, useEffect, useContext } from 'react';
import Styles from './css/Home.module.css';
import Axios from '../../components/Axios/Axios';
import ChangeRequest from '../ChangeRequests/ChangeRequest';
import Activity from './components/Activity';
import PlanCard from './components/PlanCard';
import Submitted from './components/Submitted';
import { RootStoreContext } from '../../_stores/rootStore';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import useTargetingPermissions from '../TargetingV2/hooks/useTargetingPermissions'
import { ExercisesContext } from '../../ExercisesContext'

function Home(props) {
    const rootStore = useContext(RootStoreContext);
    const { permissions } = rootStore.permissionsStore;
    const { user, isAuthenticated } = rootStore.userStore;
    const { isAdminUser, isMultiExerciseUser } = useTargetingPermissions()
    const exercises = useContext(ExercisesContext)
    const [viewValue, setViewValue] = useState(-1);
    const [editIDValue, setEditIDValue] = useState('');
    const [submitted, setSubmitted] = useState('');
    const [activities, setActivities] = useState('');
    const [showCommmentBut, setCommentButton] = useState(false);

    useEffect(() => {
        Axios('/api/v1/home/details', user, (results) => {
            let submitted = [];
            let activity_list = [];

            if (results.submitted) {
                for (let i = 0; i < results.submitted.length; i++) {
                    if (!['Approve Regional Plan Exercise', 'CP_PASSWORD_RESET'].includes(results.submitted[i].REQUEST_TYPE)) {
                        submitted.push(results.submitted[i]);
                    }
                }
                setSubmitted(submitted.reverse());
            }
            if (results.activity) {
                for (let i = 0; i < results.activity.length; i++) {

                    activity_list.push(results.activity[i]);

                }
                setActivities(activity_list);

            }



        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeHomeView = (value) => {
        setViewValue(value);
    };

    const close = () => {
        setViewValue(-1);
    };

    const setEditID = (id) => {
        setCommentButton(false);
        setEditIDValue(id);
        changeHomeView(0);
    };
    const setEditIDWithComments = (id) => {
        setCommentButton(true);
        setEditIDValue(id);
        changeHomeView(0);
    };
    const updateSubmitted = () => {
        setViewValue(-1);
        window.location.reload();
    };

    let activityPanel =
        (['DIR', 'MSL', 'OCNE', 'NAM', 'SA NAM', 'ADMIN', 'DTS', 'DBD', 'ITS', 'IDD', 'PRT', 'COMMERCIAL DERM'].includes(user.role) || user.isDermAdmin == 'true' ||
            ['11', '12', '13', '15', '14', '21', '31', '32'].includes(user.team)) && user.role != 'PHARMFORCE' ? (
            <div className={Styles.box}>
                <div className={Styles.boxTitle}>Activity</div>

                <Activity user={user} activities={activities} setEditID={setEditIDWithComments} />
            </div>
        ) : (
            ''
        );

    let exerciseCards = []

    if (exercises) {
        if (
            isAdminUser
        ) {
            if (exercises.targeting) {
                for (let i = 0; i < exercises.targeting.length; i++) {
                    exerciseCards.push(<PlanCard key={exercises.targeting[i].ID} {...props} destination={`/targeting/admin/${exercises.targeting[i].ID}`} name={exercises.targeting[i].NAME} exerciseType={"Targeting Exercise"} date={`${exercises.targeting[i].START_DATE} until ${exercises.targeting[i].END_DATE}`} icon={<i className="fas fa-bullseye"></i>} />)
                }
            }
        }
        else if (isMultiExerciseUser) {
            if (exercises.targeting) {
                for (let i = 0; i < exercises.targeting.length; i++) {
                    exerciseCards.push(<PlanCard key={exercises.targeting[i].ID} {...props} destination={`/targeting/${exercises.targeting[i].ID}`} name={exercises.targeting[i].NAME} exerciseType={"Targeting Exercise"} date={`${exercises.targeting[i].START_DATE} until ${exercises.targeting[i].END_DATE}`} icon={<i className="fas fa-bullseye"></i>} />)
                }
            }
        }
        else {
            if (exercises.targeting && exercises.targeting.length > 0) {
                if (exercises.targeting.length > 1) {
                    // Cross-team elevated viewer: show all exercises with ID-based links
                    for (let i = 0; i < exercises.targeting.length; i++) {
                        exerciseCards.push(<PlanCard key={exercises.targeting[i].ID} {...props} destination={`/targeting/${exercises.targeting[i].ID}`} name={exercises.targeting[i].NAME} exerciseType={"Targeting Exercise"} date={`${exercises.targeting[i].START_DATE} until ${exercises.targeting[i].END_DATE}`} icon={<i className="fas fa-bullseye"></i>} />)
                    }
                } else {
                    const exercise = exercises.targeting[0]
                    exerciseCards.push(<PlanCard key={1} {...props} destination={'/targeting'} name={exercise.NAME} exerciseType={"Targeting Exercise"} date={`${exercise.START_DATE} until ${exercise.END_DATE}`} icon={<i className="fas fa-bullseye"></i>} />)
                }
            }
        }
    }


    let exercisePanel =
        (permissions.targeting.home.exercisePanel.include.roles.includes(user.role) ||
            permissions.targeting.home.exercisePanel.include.teams.includes(user.team) && 
                (!permissions.targeting.home.exercisePanel.exclude.roles.includes(user.role))) ? (
            <div className={Styles.box}>
                <div className={Styles.boxTitle}>Exercises</div>
                <div className={Styles.wrapper}>{exerciseCards}</div>
            </div>
        ) : (
            ''
        );

    return (
        <div
            className={
                ['DIR', 'MSL', 'OCNE', 'NAM', 'SA NAM', 'ADMIN', 'DTS', 'DBD', 'ITS', 'IDD'].includes(user.role) ||
                    ['11', '12', '13', '15', '14', '21', '31', '32'].includes(user.team)
                    ? Styles.Home
                    : Styles.HomeChanges
            }>
            {viewValue !== -1 ? <ChangeRequest data={editIDValue} callback={updateSubmitted} user={user} close={close} showComments={showCommmentBut} /> : ''}
            <div className={Styles.row}>
                {activityPanel}
                {exercisePanel}
            </div>
            <div className={Styles.row}>
                <div className={Styles.box}>
                    <div className={Styles.boxTitle}>Your Submitted Requests</div>
                    <div className={Styles.titles}>
                        <div className={Styles.content}>ACTION ID</div>
                        <div className={Styles.content}>STATUS</div>
                        <div className={Styles.content}>REQUEST DATE</div>
                        <div className={Styles.content}>HCP/ORG NAME</div>
                        <div className={Styles.content}>REQUEST TYPE</div>
                        <div className={Styles.content}>COMMENTS</div>
                        <div className={Styles.content}>LAST MODIFIED DATE</div>
                    </div>
                    <Submitted data={submitted} setEditID={setEditID} changeHomeView={changeHomeView} />
                </div>
            </div>
        </div>
    );
}

export default withAITracking(reactPlugin, Home);